import {
  RETRIEVE_OUTBOUND_REPORTS_REQUEST,
  RETRIEVE_OUTBOUND_REPORTS_SUCCESS,
  RETRIEVE_OUTBOUND_REPORTS_FAILURE,
  REPORTS_CHECKED,
  SELECT_ALL_REPORTS,
  DESELECT_ALL_REPORTS,
} from './types/ReportsActionTypes';

export function retrieveOutboundReportsRequestActionCreator(payload, checkedReports) {
  return {
    type: RETRIEVE_OUTBOUND_REPORTS_REQUEST,
    payload,
    checkedReports,
  };
}

export function retrieveOutboundReportsSuccessActionCreator(payload) {
  return {
    type: RETRIEVE_OUTBOUND_REPORTS_SUCCESS,
    payload,
  };
}

export function retrieveOutboundReportsFailureActionCreator(error) {
  return {
    type: RETRIEVE_OUTBOUND_REPORTS_FAILURE,
    error,
  };
}

export function reportsCheckedActionCreator(checkedReports) {
  return {
    type: REPORTS_CHECKED,
    checkedReports,
  };
}

export function onSelectAllReports(nodes) {
  return {
    type: SELECT_ALL_REPORTS,
    payload: {
      nodes,
    },
  };
}

export function onDeSelectAllReports() {
  return {
    type: DESELECT_ALL_REPORTS,
  };
}
